import { cookieConsent } from '../../setup/settings/index';
import { useEffect, useState } from "react";

export default function CookieConsent() {

  const [showNotification, setShowNotification] = useState(false);
  const [expirationDate, setExpirationDate] = useState('');

  const acceptCookies = () => {
    document.cookie = `cookieConsent=true; expires=${expirationDate}; path=/`;
    setShowNotification(false);
  };

  const declineCookies = () => {
    document.cookie = `cookieConsent=false; expires=${expirationDate}; path=/`;
    setShowNotification(false);
  };

  const getExpirationDate = () => {
    const oneYearMilliseconds = 365 * 24 * 60 * 60 * 1000;
    const actualDate = new Date();
    const expirationDate = new Date(actualDate.getTime() + oneYearMilliseconds);
    return expirationDate.toUTCString();
  };

  const verificationAcceptCookies = () => {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.split('=');
      if (name.trim() === 'cookieConsent' && (value.trim() === 'true' || value.trim() === 'false')) {
        setShowNotification(false);
        return;
      }
    }
    setShowNotification(true);
    setExpirationDate(getExpirationDate());
  };

  useEffect(() => {
    verificationAcceptCookies();
  }, []);

  return (
    <>
      {showNotification && (
        <div className="cookie-notification">
          <div className="cookie-row">
            <div className="cookie-column">
              {cookieConsent.icon.show && (
                <img src={cookieConsent.icon.url} alt="Cookie" className="cookie-image" />
              )}
            </div>
            <div>
              <p>
                {cookieConsent.message}
                <br />
                <a className='learn-more' href={cookieConsent.privacyLink}>
                  {cookieConsent.privacyLinkText}
                </a>
              </p>
            </div>
          </div>
          <div className="cookie-row">
            <button onClick={declineCookies} className="cookie-decline-button">
              {cookieConsent.denyButtonText}
            </button>
            <button onClick={acceptCookies} className="cookie-got-it-button">
              {cookieConsent.agreeButtonText}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
